import { ComboSlotType } from 'features/menu/components/product-detail/product-customization/types';
import { ProductWizardStep } from 'features/menu/components/product-wizard/types';
import { capitalize } from 'lodash-es';

import { EntryTypeEnum } from 'generated/graphql-gateway';

export const isCustomization = (step: ProductWizardStep) =>
  [
    ProductWizardStep.ProductCustomization,
    ProductWizardStep.PickerCustomization,
    ProductWizardStep.PickerCustomizationSides,
    ProductWizardStep.PickerCustomizationDrinks,
  ].includes(step);

export const QUANTITY_DEFAULTS = { min: 0, max: 1 };

export const transformProductWizardStepToEventAttr = (currentStep: ProductWizardStep): string => {
  return (currentStep ?? '').replace(/([a-z])([A-Z])/g, '$1 $2');
};

interface IGetEventAttributesForCustomization {
  currentStep: ProductWizardStep;
  menuObjectType: EntryTypeEnum;
  comboSlotType?: ComboSlotType;
}

export enum ProductCustomizationEvents {
  PRODUCT_CUSTOMIZATION = 'Product Customization',
  PRODUCT_EDIT_ORDER = 'Product Edit Order',
}

export const getEventAttributesForCustomization = ({
  currentStep,
  menuObjectType,
  comboSlotType,
}: IGetEventAttributesForCustomization): { [key: string]: string } => {
  switch (currentStep) {
    case ProductWizardStep.PickerCustomization:
      return {
        name: ProductCustomizationEvents.PRODUCT_CUSTOMIZATION,
        comboSlotType: 'Item',
      };
    case ProductWizardStep.PickerCustomizationSides:
    case ProductWizardStep.PickerCustomizationDrinks:
      return {
        name: ProductCustomizationEvents.PRODUCT_CUSTOMIZATION,
        comboSlotType: capitalize(comboSlotType?.toString() ?? ''),
      };
    case ProductWizardStep.ProductCustomization:
      // Combo Flow
      if (menuObjectType === EntryTypeEnum.COMBO) {
        return {
          name: ProductCustomizationEvents.PRODUCT_CUSTOMIZATION,
          comboSlotType: capitalize(comboSlotType?.toString() ?? ''),
        };
      }
      // Picker Combo Slot Edit Customization
      return {
        name: ProductCustomizationEvents.PRODUCT_EDIT_ORDER,
        comboSlotType:
          comboSlotType === ComboSlotType.PICKER_ASPECT
            ? 'Item'
            : capitalize(comboSlotType?.toString() ?? ''),
      };
    default:
      return {};
  }
};
